import React, { useState, useEffect } from 'react';
import { Formik, Form } from 'formik';

import * as Yup from 'yup';
import { SelectUserByUserID as USER_SELECT_BY_ID } from 'Components/Api/UsersApi';
import { LOGOUT } from 'ConstComponents';
import {
    Registration as VLE_REGISTRATION,
    SelectByUserID as SELECT_DATA
} from 'Components/Api/PanMitraAPI';
import { StateItem } from 'Components/ReportHelper';

import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import { MaterialSelect } from 'Components/Inputes/FormikMaterialSelect';
import {
    Container,
    Grid,
    Paper,
    MenuItem,
    CircularProgress,
    Button,
    Box
} from '@material-ui/core';
import ReactTable from 'Components/ReactTable/ReactTable';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import {
    MESSAGE_CLOSE_AFTER,
    PLEASE_PROVIDE_VALID
} from 'Components/Helper/Messages';
import { useHistory } from 'react-router';
import HOCLoader from 'Components/Loader/HOCLoader';
import { MaterialNumberField } from 'Components/Inputes/FormikMaterialNumberInput';
import {
    PrimaryButton,
    SecondaryButton
} from 'Components/Inputes/CustomButton';
const CustomContainer = HOCLoader(Container);

export const VleRegistration = () => {
    const history = useHistory();
    const classes = commonStyle();
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = React.useState(false);
    const [severity, setSeverity] = useState('success');
    const [stateList, setStateList] = useState([]);
    const [itemList, setItemList] = useState([]);
    const [mainColumns, setMainColumns] = useState([]);

    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        if (loading) {
            setLoading(false);
            return;
        }
        var requestObj = JSON.stringify(values);
        setSubmitting(false);
        setIsError(false);
        setLoading(true);

        var response = await VLE_REGISTRATION(requestObj);

        setLoading(false);

        if (!response.isAuthorized) LOGOUT();

        setSubmitting(true);

        setIsError(true);

        if (!response.status) {
            setSeverity('error');
            setIsError(true);
            setResponseMessage(response.data);
            return;
        }

        setSeverity('success');

        resetForm(FormObj);
        resetForm(FormData);
        // selectData();
        setTimeout(() => {}, MESSAGE_CLOSE_AFTER);
    };

    const FormValidationSchema = Yup.object({
        Name: Yup.string().required(PLEASE_PROVIDE_VALID + 'Name'),

        FirmName: Yup.string()
            .trim()
            .required(PLEASE_PROVIDE_VALID + 'firm name'),

        MobileNumber: Yup.string()
            .trim()
            .length(10, PLEASE_PROVIDE_VALID + 'mobile number')
            .required(PLEASE_PROVIDE_VALID + 'mobile number'),
        EmailID: Yup.string()
            .trim()
            .email()
            .required(PLEASE_PROVIDE_VALID + 'email address'),
        Address: Yup.string()
            .trim()
            .required(PLEASE_PROVIDE_VALID + 'address')
            .max(150, 'Please enter address with 150 char. only'),

        PANNo: Yup.string().required(PLEASE_PROVIDE_VALID + 'pan no'),

        Pincode: Yup.string()
            .trim()
            .length(6, PLEASE_PROVIDE_VALID + 'pin code')
            .required(PLEASE_PROVIDE_VALID + 'pin code')
    });

    const selectData = async () => {
        const { isAuthorized, status, data } = await SELECT_DATA();

        setLoading(false);
        if (!isAuthorized) LOGOUT();

        if (!status) {
            setIsError(true);
            setSeverity('error');
            setResponseMessage(data);

            return;
        }
        var d = JSON.parse(data);

        setItemList(d);
    };

    const SelectByID = async () => {
        setLoading(true);
        const response = await USER_SELECT_BY_ID();
        if (!response.isAuthorized) LOGOUT();

        setLoading(false);
        var data = JSON.parse(response.data);

        setFormObj({
            Name: data.PersonName,
            MobileNumber: data.MobileNumber,
            FirmName: data.FirmName,
            Address: data.Address,
            Pincode: data.Pincode,
            PANNo: data.PANNo,
            EmailID: data.EmailID
        });
    };
    const [FormObj, setFormObj] = useState({
        Name: '',
        MobileNumber: '',
        FirmName: '',
        EmailID: '',
        State: '',
        Address: '',
        Pincode: '',
        PANNo: ''
    });

    const createColumns = () => {
        var columns = [];
        var statusIndex = 1;
        columns.push({
            label: 'Status',
            name: 'Status',
            hide: true
        });
        columns.push({
            label: '#',
            name: 'ID',
            srno: true
        });
        columns.push({
            label: 'Name',
            name: 'FirmName'
        });
        columns.push({
            label: 'VleID',
            name: 'VleID'
        });

        columns.push({
            label: 'EmailID',
            name: 'EmailID'
        });

        columns.push({
            label: 'Status',
            name: 'Status',
            customStatus: true
        });
        // var options = [
        //     {
        //         Title: 'Check',
        //         disabledOn: ['FAILURE', 'SUCCESS'],
        //         statusIndex: statusIndex,
        //         Callback: (values) => {
        //             StatusCheck(values[2]);
        //         }
        //     }
        // ];
        // columns.splice(0, 0, {
        //     label: ' ',
        //     name: 'ID',
        //     MoreMenu: true,
        //     options: options
        // });

        setMainColumns(columns);
    };

    useEffect(() => {
        SelectByID();
        createColumns();
        selectData();
    }, []);

    const UploadForm = (formProps) => {
        return (
            <Grid
                item
                container
                margin="normal"
                xs={12}
                md={12}
                sm={12}
                lg={12}
                spacing={2}
            >
                <Grid item xs={12} sm={12} md={6} lg={4}>
                    <Form>
                        <Grid container spacing={2}>
                            <Grid xs={12} sm={12} md={6} lg={6}>
                                {' '}
                                <Grid xs={12} sm={12} md={6} lg={6}>
                                    <h2 className={classes.PaperHead_h2}>
                                        Registration
                                    </h2>
                                </Grid>
                            </Grid>
                            <Grid xs={12} sm={12} md={6} lg={6}>
                                <Box className={classes.flexReverse}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        className={
                                            classes.CustomPrimaryButtonStyle
                                        }
                                        onClick={() => {
                                            history.push('/CouponBuy');
                                        }}
                                    >
                                        Coupon Buy
                                    </Button>
                                </Box>
                            </Grid>
                        </Grid>
                        <Paper className={classes.PaperStyle}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <MaterialTextField
                                        label="Name"
                                        name="Name"
                                        type="text"
                                        placeholder="Name"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <MaterialNumberField
                                        label="MobileNumber"
                                        name="MobileNumber"
                                        type="text"
                                        length={10}
                                        placeholder="MobileNumber"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <MaterialTextField
                                        label="Shop Name"
                                        name="FirmName"
                                        type="text"
                                        placeholder="Shop Name"
                                    />
                                </Grid>

                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <MaterialTextField
                                        label="EmailID"
                                        name="EmailID"
                                        type="text"
                                        placeholder="EmailID"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <MaterialSelect
                                        name="State"
                                        label="State"
                                        title="State"
                                    >
                                        <MenuItem key="0" value="0">
                                            State
                                        </MenuItem>
                                        {StateItem}
                                    </MaterialSelect>
                                </Grid>

                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <MaterialTextField
                                        label="Address"
                                        name="Address"
                                        type="text"
                                        placeholder="Address"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <MaterialNumberField
                                        label="Pin code"
                                        name="Pincode"
                                        type="text"
                                        length={6}
                                        title="Pin code"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <MaterialTextField
                                        label="PAN Number"
                                        name="PANNo"
                                        type="text"
                                        length={10}
                                        title="PAN Number"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} lg={6}>
                                    <SecondaryButton
                                        type="reset"
                                        variant="contained"
                                        color="secondary"
                                        title="Reset"
                                        className={
                                            classes.CustomDangerButtonStyle
                                        }
                                    >
                                        Reset
                                    </SecondaryButton>
                                </Grid>

                                <Grid item xs={12} sm={12} md={6} lg={6}>
                                    <PrimaryButton
                                        type="submit"
                                        title="Registration"
                                        className={
                                            classes.CustomPrimaryButtonStyle
                                        }
                                        disabled={loading}
                                    >
                                        Registration
                                    </PrimaryButton>
                                    {loading && (
                                        <CircularProgress
                                            size={24}
                                            className={classes.buttonProgress}
                                        />
                                    )}
                                </Grid>
                            </Grid>
                        </Paper>
                    </Form>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={8} className="Report">
                    <h2 className={classes.PaperHead_h2}>
                        Registration Details
                    </h2>
                    <ReactTable data={itemList} columns={mainColumns} />
                </Grid>
            </Grid>
        );
    };

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                enableReinitialize={true}
                initialValues={FormObj}
                validationSchema={FormValidationSchema}
                onSubmit={handleSubmit}
                resetForm={FormObj}
            >
                {UploadForm}
            </Formik>
        </CustomContainer>
    );
};
